import { ActiveButton, BitmapTextStyleOpts } from '../../../ui';
import { LoadContext } from "../../../utils";
import {
    Texture,
    Sprite,
    NineSlicePlane,
} from 'pixi.js';

const TEXT_PADDING = 50;

export class RadioButton extends ActiveButton
{
    protected textBG: Sprite|NineSlicePlane;

    public static preload()
    {
        LoadContext.current.add('Settings', './assets/accessibility/Settings{size}.json');
    }

    constructor( label:string, textstyle:BitmapTextStyleOpts = {fontName:'Asap'}, textBG?: number|NineSlicePlane )
    {
        // defaults
        if( !textstyle.fontName) {
            textstyle.fontName = 'Asap';
        }
        if( !("fontSize" in textstyle ) ) {
            textstyle.fontSize = 38;
        }

        if( !("tint" in textstyle ) ) {
            textstyle.tint = 0x000000;
        }

        super(
            LoadContext.current.getSpritesheet('Settings').textures['btn_radiobtn0001'],
            {
                content: label,
                style: textstyle,
                offset: { x: TEXT_PADDING, y: 0}
            },
            LoadContext.current.getSpritesheet('Settings').textures['btn_radiobtn0002']
        );

        this.text.anchor.set(0, 0.6);
        this.activeText = this.text;

        if (textBG !== undefined)
        {
            if (typeof textBG === 'number')
            {
                this.textBG = new Sprite(Texture.WHITE);
                this.textBG.tint = textBG;
                this.textBG.width = this.text.width + 20;
                this.textBG.height = this.text.height + 10;
                this.textBG.position.copyFrom(this.text.position);
                this.textBG.x -= 10;
                this.textBG.anchor.set(0, 0.5);
            }
            else
            {
                this.textBG = textBG;
                this.textBG.width = this.text.width + 20;
                this.textBG.height = this.text.height + 10;
                this.textBG.position.set(this.text.x - 10, this.text.y - this.textBG.height / 2);
            }
            this.addChildAt(this.textBG, 0);
        }
    }

    protected createFocus()
    {
        super.createFocus();
        this.focusBox.x = -this.sprite.width / 2 - 10;
    }

    protected getSize()
    {
        return {width: this.sprite.width + TEXT_PADDING + this.text.width, height: this.sprite.height};
    }
}